module.exports = __webpack_public_path__ + "static/media/WhatsTheWeatherSS.4752b6ae.png";